// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif !important;
}

body {
  font-family: "Roboto", sans-serif !important;
}

.any-desc {
  grid-column: 1/-1;
}
.any-desc > div {
  width: 100%;
}
.any-desc p {
  line-height: 1.4rem !important;
  font-weight: 400 !important;
}

.filter-panel {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.filter-toggle-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}

.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 1rem;
  margin-top: 10px;
  align-items: center;
  background: #f1f3f5;
  padding: 10px 15px;
  border-radius: 10px;
}
.applied-filters .filters-text {
  color: black;
  font-size: 14px;
  background: none;
}
.applied-filters .filter-tag {
  cursor: pointer;
}
.applied-filters strong {
  font-size: 14px;
  color: #343a40;
  margin-right: 10px;
}
.applied-filters span {
  background: #dbeafe;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  color: var(--primary-color);
  font-weight: 500;
}
.applied-filters .clear-all-tag {
  background: var(--danger-color);
  color: #fff;
  font-size: 12px;
}

.invoices-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.filter-dropdown-wrapper {
  position: relative;
}

.filter-dropdown-box {
  position: fixed;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 1rem;
  padding-bottom: 0rem;
  width: 365px;
  z-index: 99999;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.filter-dropdown-box .filter-group {
  display: flex;
  flex-direction: column;
}
.filter-dropdown-box .filter-group label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #333;
}
.filter-dropdown-box .filter-group input,
.filter-dropdown-box .filter-group select {
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
}
.filter-dropdown-box .filter-actions {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-top: 1px solid #ddd;
  background-color: white;
  z-index: 100;
}
.filter-dropdown-box .filter-actions .clear-btn,
.filter-dropdown-box .filter-actions .hide-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
}
.filter-dropdown-box .filter-actions .clear-btn {
  background-color: #dc3545;
  color: white;
}
.filter-dropdown-box .filter-actions .hide-btn {
  background-color: #6c757d;
  color: white;
}

.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.global-loading-overlay .loading-container {
  border-radius: 12px;
  padding: 2rem;
  min-height: auto;
}

.common-pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 4px 10px;
  background-color: #e2e8f0;
  border-radius: 6px;
}
.common-pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 0.85rem;
  font-weight: 400;
}
.common-pagination-settings #clientPerPageSelect, .common-pagination-settings #invoicePerPageSelect, .common-pagination-settings #expensePerPageSelect, .common-pagination-settings #labelPerPageSelect,
.common-pagination-settings #notePerPageSelect, .common-pagination-settings #userPerPageSelect, .common-pagination-settings #tasksPerPageSelect, .common-pagination-settings #casesPerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 3px 28px 3px 3px;
  background-color: white;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.common-pagination-settings #clientPerPageSelect:hover, .common-pagination-settings #invoicePerPageSelect:hover, .common-pagination-settings #expensePerPageSelect:hover, .common-pagination-settings #labelPerPageSelect:hover,
.common-pagination-settings #notePerPageSelect:hover, .common-pagination-settings #userPerPageSelect:hover, .common-pagination-settings #tasksPerPageSelect:hover, .common-pagination-settings #casesPerPageSelect:hover {
  background-color: #fafafa;
}
.common-pagination-settings #clientPerPageSelect:focus, .common-pagination-settings #invoicePerPageSelect:focus, .common-pagination-settings #expensePerPageSelect:focus, .common-pagination-settings #labelPerPageSelect:focus,
.common-pagination-settings #notePerPageSelect:focus, .common-pagination-settings #userPerPageSelect:focus, .common-pagination-settings #tasksPerPageSelect:focus, .common-pagination-settings #casesPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.common-pagination-settings #clientPerPageSelect option, .common-pagination-settings #invoicePerPageSelect option, .common-pagination-settings #expensePerPageSelect option, .common-pagination-settings #labelPerPageSelect option,
.common-pagination-settings #notePerPageSelect option, .common-pagination-settings #userPerPageSelect option, .common-pagination-settings #tasksPerPageSelect option, .common-pagination-settings #casesPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}
.common-pagination-settings #userPerPageSelect, .common-pagination-settings #tasksPerPageSelect, .common-pagination-settings #casesPerPageSelect {
  padding: 4px 28px 4px 3px !important;
}

.lawyer-list {
  background-color: #f8f9fa;
  padding: 15px;
}
.lawyer-list .filter-group label {
  display: block;
  margin-bottom: 8px;
}
.lawyer-list .no-lawyers-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}
.lawyer-list .spreadsheet-filter-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.lawyer-list .spreadsheet-filter-header .invoices-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .common-pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 4px 10px;
  background-color: #e2e8f0;
  border-radius: 6px;
}
.lawyer-list .spreadsheet-filter-header .invoices-header .filter-dropdown-wrapper {
  margin-left: auto;
}
.lawyer-list .lawyer-cards {
  margin-top: 1rem;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  animation: fadeIn 0.3s ease-out;
}
.lawyer-list .lawyer-card {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  min-height: 180px;
}
.lawyer-list .lawyer-card:hover {
  border-color: #d1d5db;
}
.lawyer-list .lawyer-card:hover .userscrud {
  opacity: 1;
}
.lawyer-list .lawyer-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.lawyer-list .lawyer-card .card-header h3 {
  margin: 0;
  color: #1f2937;
  font-weight: 600;
  font-size: 1.1rem;
  flex: 1 1;
}
.lawyer-list .lawyer-card .card-header .status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.lawyer-list .lawyer-card .card-header .status-badge.active {
  background-color: #dcfce7;
  color: #166534;
}
.lawyer-list .lawyer-card .card-header .status-badge.inactive {
  background-color: #fef2f2;
  color: #dc2626;
}
.lawyer-list .lawyer-card .card-content {
  flex: 1 1;
}
.lawyer-list .lawyer-card .card-content .info-item {
  display: flex;
  margin-bottom: 0.5rem;
}
.lawyer-list .lawyer-card .card-content .info-item .label {
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 60px;
  margin-right: 0.5rem;
}
.lawyer-list .lawyer-card .card-content .info-item .value {
  color: #374151;
  font-size: 0.875rem;
  flex: 1 1;
  word-break: break-word;
}
.lawyer-list .lawyer-card .card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f3f4f6;
}
.lawyer-list .lawyer-card .card-footer .role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}
.lawyer-list .lawyer-card .card-footer .userscrud {
  display: flex;
  gap: 0.5rem;
  transition: opacity 0.2s ease;
}
.lawyer-list .lawyer-card .card-footer .userscrud .btn {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.lawyer-list .lawyer-card .card-footer .userscrud .btn:hover {
  background-color: #f8f9fa;
  opacity: 0.9;
}
.lawyer-list .users-table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.lawyer-list .users-table thead {
  background-color: var(--light-gray);
}
.lawyer-list .users-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.lawyer-list .users-table tbody tr {
  transition: background-color 0.2s ease;
}
.lawyer-list .users-table tbody tr:hover {
  background-color: #f9fafb;
}
.lawyer-list .users-table tbody tr td {
  padding: 0.9rem 1rem;
}
.lawyer-list .users-table tbody tr td:nth-child(4) .role-badge-status {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 12px;
}
.lawyer-list .users-table tbody tr td:nth-child(4) .role-badge-status.active {
  background-color: #dcfce7;
  color: #166534;
}
.lawyer-list .users-table tbody tr td:nth-child(4) .role-badge-status.inactive {
  background-color: #fef2f2;
  color: #dc2626;
}
.lawyer-list .users-table tbody tr td:last-child {
  white-space: nowrap;
}
.lawyer-list .users-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #17a2b8;
  color: white;
  opacity: 0.9;
}
.lawyer-list .users-table tbody tr td:last-child button:last-child {
  background-color: #dc2626;
}
.lawyer-list .users-table tbody tr td:last-child button:hover {
  opacity: 0.9;
}
.lawyer-list .pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.lawyer-list .pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.lawyer-list .pagination-settings #userPerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.lawyer-list .pagination-settings #userPerPageSelect:hover {
  background-color: #fafafa;
}
.lawyer-list .pagination-settings #userPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.lawyer-list .pagination-settings #userPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

@media (max-width: 768px) {
  .lawyer-list .lawyer-cards .lawyer-card .userscrud {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_base.scss","webpack://./src/pages/AddUsers/AddUsers.scss"],"names":[],"mappings":"AAGA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,4CAAA;ACAF;;ADKA;EACE,4CAAA;ACFF;;ADIA;EACE,iBAAA;ACDF;ADGE;EACE,WAAA;ACDJ;ADGE;EACE,8BAAA;EACA,2BAAA;ACDJ;;ADKA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;ACFF;;ADKA;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;ACFF;;ADKA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACFF;ADIE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;ACFJ;ADIE;EACE,eAAA;ACFJ;ADKE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;ACHJ;ADME;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;ACJJ;ADME;EACE,+BAAA;EACA,WAAA;EACA,eAAA;ACJJ;;ADQA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,kBAAA;ACNF;;ADSA;EACE,kBAAA;ACNF;;ADSA;EACE,eAAA;EAEA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;ACRF;ADUE;EACE,aAAA;EACA,sBAAA;ACRJ;ADUI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ACRN;ADWI;;EAEE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,oBAAA;ACVN;ADcE;EACC,gBAAA;EACC,SAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;ACZJ;ADcI;;EAEE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;ACZN;ADeI;EACE,yBAAA;EACA,YAAA;ACbN;ADgBI;EACE,yBAAA;EACA,YAAA;ACdN;;ADkBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;ACfF;ADiBE;EAEE,mBAAA;EACA,aAAA;EAEA,gBAAA;ACjBJ;;ADoBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;ACjBJ;ADmBI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ACjBN;ADoBI;;EAEE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EAKA,gBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAEA,yBAAA;EACA,2BAAA;ACtBN;ADwBM;;EACE,yBAAA;ACrBR;ADwBM;;EACE,wDAAA;EACA,uBAAA;ACrBR;ADwBM;;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;ACrBR;ADyBI;EACG,oCAAA;ACvBP;;AA3NA;EACE,yBAAA;EACA,aAAA;AA8NF;AA7NE;EACE,cAAA;EACA,kBAAA;AA+NJ;AA7NE;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA+NJ;AA5NE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;AA8NJ;AA5NI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;AA8NN;AA5NM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA8NR;AA5NQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA8NV;AA5NU;EACE,eAAA;EACA,cAAA;AA8NZ;AA3NU;EACE,yBAAA;AA6NZ;AA1NU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AA4NZ;AAvNM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAyNR;AAtNM;EACE,iBAAA;AAwNR;AAnNE;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,2DAAA;EACA,+BAAA;AAqNJ;AAlNE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAoNJ;AAlNI;EACE,qBAAA;AAoNN;AAlNM;EACE,UAAA;AAoNR;AAhNI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAkNN;AAhNM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAkNR;AA/MM;EACE,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AAiNR;AA/MQ;EACE,yBAAA;EACA,cAAA;AAiNV;AA9MQ;EACE,yBAAA;EACA,cAAA;AAgNV;AA3MI;EACE,SAAA;AA6MN;AA3MM;EACE,aAAA;EACA,qBAAA;AA6MR;AA3MQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA6MV;AA1MQ;EACE,cAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AA4MV;AAvMI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAyMN;AAvMM;EACE,qBAAA;EACA,wBAAA;EACA,sCAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAyMR;AAtMM;EACE,aAAA;EACA,WAAA;EACA,6BAAA;AAwMR;AAtMQ;EASG,oBAAA;EACC,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAgMZ;AA/LY;EACE,yBAAA;EACA,YAAA;AAiMd;AA1LE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AA4LJ;AA1LI;EACE,mCAAA;AA4LN;AA1LM;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AA4LR;AAvLM;EACE,sCAAA;AAyLR;AAvLQ;EACE,yBAAA;AAyLV;AAtLQ;EACE,oBAAA;AAwLV;AApLU;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAsLZ;AApLY;EACE,yBAAA;EACA,cAAA;AAsLd;AAnLY;EACE,yBAAA;EACA,cAAA;AAqLd;AAhLQ;EACE,mBAAA;AAkLV;AAhLU;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAkLZ;AAhLY;EACE,yBAAA;AAkLd;AA/KY;EACE,YAAA;AAiLd;AAzKE;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AA2KF;AAxKE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA0KJ;AAtKE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AAkKJ;AA/JI;EACE,yBAAA;AAiKN;AA7JI;EACE,wDAAA;EACA,uBAAA;AA+JN;AA3JI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AA6JN;;AAvJA;EAIQ;IACE,UAAA;EAuJR;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;500;700&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  font-family: \"Roboto\", sans-serif !important;\r\n}\r\n// body {\r\n//   font-family: \"Inter\", sans-serif;\r\n// }\r\nbody {\r\n  font-family: \"Roboto\", sans-serif !important;\r\n}\r\n.any-desc {\r\n  grid-column: 1 / -1; // Span full width\r\n\r\n  > div {\r\n    width: 100%;\r\n  }\r\n  p{\r\n    line-height: 1.4rem !important;\r\n    font-weight: 400 !important;\r\n  }\r\n}\r\n\r\n.filter-panel {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.filter-toggle-btn {\r\n  padding: 8px 18px;\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 0.5rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.applied-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-bottom: 1rem;\r\n  margin-top: 10px;\r\n  align-items: center;\r\n  background: #f1f3f5;\r\n  padding: 10px 15px;\r\n  border-radius: 10px;\r\n\r\n  .filters-text{\r\n    color: black;\r\n    font-size: 14px;\r\n    background:none;\r\n  }\r\n  .filter-tag{\r\n    cursor: pointer;\r\n  }\r\n\r\n  strong {\r\n    font-size: 14px;\r\n    color: #343a40;\r\n    margin-right: 10px;\r\n  }\r\n\r\n  span {\r\n    background: #dbeafe;\r\n    padding: 4px 10px;\r\n    border-radius: 8px;\r\n    font-size: 13px;\r\n    color: var(--primary-color);\r\n    font-weight: 500;\r\n  }\r\n  .clear-all-tag{\r\n    background: var(--danger-color);\r\n    color: #fff;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n.invoices-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  // margin-bottom: 1rem;\r\n  position: relative;\r\n}\r\n// Use fixed positioning to bypass all parent containers\r\n.filter-dropdown-wrapper {\r\n  position: relative;\r\n}\r\n\r\n.filter-dropdown-box {\r\n  position: fixed; // Use fixed instead of absolute\r\n  // We'll calculate the position using JavaScript\r\n  background: #ffffff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 10px;\r\n  padding: 1rem;\r\n  padding-bottom: 0rem;\r\n  width: 365px;\r\n  z-index: 99999; // Very high z-index\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n\r\n  .filter-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    label {\r\n      font-size: 13px;\r\n      font-weight: 500;\r\n      margin-bottom: 4px;\r\n      color: #333;\r\n    }\r\n\r\n    input,\r\n    select {\r\n      padding: 6px 10px;\r\n      border: 1px solid #ced4da;\r\n      border-radius: 6px;\r\n      font-size: 14px;\r\n      //font family inherit\r\n      font-family: inherit;\r\n    }\r\n  }\r\n\r\n  .filter-actions {\r\n   position: sticky;\r\n    bottom: 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n    border-top: 1px solid #ddd;\r\n    background-color: white;\r\n    z-index: 100;\r\n\r\n    .clear-btn,\r\n    .hide-btn {\r\n      padding: 6px 12px;\r\n      border: none;\r\n      border-radius: 6px;\r\n      font-weight: 500;\r\n      font-size: 13px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .clear-btn {\r\n      background-color: #dc3545;\r\n      color: white;\r\n    }\r\n\r\n    .hide-btn {\r\n      background-color: #6c757d;\r\n      color: white;\r\n    }\r\n  }\r\n}\r\n.global-loading-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n\r\n  .loading-container {\r\n    // background: white;\r\n    border-radius: 12px;\r\n    padding: 2rem;\r\n    // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n    min-height: auto;\r\n  }\r\n}\r\n  .common-pagination-settings {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    padding: 4px 10px;\r\n    background-color: #e2e8f0;\r\n    border-radius: 6px;\r\n\r\n    label {\r\n      white-space: nowrap;\r\n      color: #1f2937;\r\n      font-size: 0.85rem;\r\n      font-weight: 400;\r\n    }\r\n\r\n    #clientPerPageSelect , #invoicePerPageSelect , #expensePerPageSelect , #labelPerPageSelect ,\r\n    #notePerPageSelect , #userPerPageSelect , #tasksPerPageSelect , #casesPerPageSelect {\r\n      border: none;\r\n      border-radius: 6px;\r\n      outline: none;\r\n      padding: 3px 28px 3px 3px;\r\n      background-color: white;\r\n      font-size: 0.85rem;\r\n      color: #333;\r\n      cursor: pointer;\r\n      // min-width: 70px;\r\n\r\n      -webkit-appearance: none;\r\n      -moz-appearance: none;\r\n      appearance: none;\r\n\r\n      background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n      background-repeat: no-repeat;\r\n      background-position: right 10px center;\r\n      background-size: 16px;\r\n\r\n      transition: all 0.2s ease;\r\n      box-shadow: none !important;\r\n\r\n      &:hover {\r\n        background-color: #fafafa;\r\n      }\r\n\r\n      &:focus {\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n        background-color: white;\r\n      }\r\n\r\n      option {\r\n        border: none !important;\r\n        outline: none;\r\n        padding: 4px 8px;\r\n      }\r\n    }\r\n\r\n    #userPerPageSelect , #tasksPerPageSelect,#casesPerPageSelect{\r\n       padding: 4px 28px 4px 3px !important;\r\n    }\r\n  }","@import url(\"https://fonts.googleapis.com/css2?family=Lato:wght@300;400;500;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap\");\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Roboto\", sans-serif !important;\n}\n\nbody {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n.any-desc {\n  grid-column: 1/-1;\n}\n.any-desc > div {\n  width: 100%;\n}\n.any-desc p {\n  line-height: 1.4rem !important;\n  font-weight: 400 !important;\n}\n\n.filter-panel {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.filter-toggle-btn {\n  padding: 8px 18px;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n}\n\n.applied-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 1rem;\n  margin-top: 10px;\n  align-items: center;\n  background: #f1f3f5;\n  padding: 10px 15px;\n  border-radius: 10px;\n}\n.applied-filters .filters-text {\n  color: black;\n  font-size: 14px;\n  background: none;\n}\n.applied-filters .filter-tag {\n  cursor: pointer;\n}\n.applied-filters strong {\n  font-size: 14px;\n  color: #343a40;\n  margin-right: 10px;\n}\n.applied-filters span {\n  background: #dbeafe;\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--primary-color);\n  font-weight: 500;\n}\n.applied-filters .clear-all-tag {\n  background: var(--danger-color);\n  color: #fff;\n  font-size: 12px;\n}\n\n.invoices-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.filter-dropdown-wrapper {\n  position: relative;\n}\n\n.filter-dropdown-box {\n  position: fixed;\n  background: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 10px;\n  padding: 1rem;\n  padding-bottom: 0rem;\n  width: 365px;\n  z-index: 99999;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.filter-dropdown-box .filter-group {\n  display: flex;\n  flex-direction: column;\n}\n.filter-dropdown-box .filter-group label {\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: #333;\n}\n.filter-dropdown-box .filter-group input,\n.filter-dropdown-box .filter-group select {\n  padding: 6px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n}\n.filter-dropdown-box .filter-actions {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  border-top: 1px solid #ddd;\n  background-color: white;\n  z-index: 100;\n}\n.filter-dropdown-box .filter-actions .clear-btn,\n.filter-dropdown-box .filter-actions .hide-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n}\n.filter-dropdown-box .filter-actions .clear-btn {\n  background-color: #dc3545;\n  color: white;\n}\n.filter-dropdown-box .filter-actions .hide-btn {\n  background-color: #6c757d;\n  color: white;\n}\n\n.global-loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(2px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n.global-loading-overlay .loading-container {\n  border-radius: 12px;\n  padding: 2rem;\n  min-height: auto;\n}\n\n.common-pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 4px 10px;\n  background-color: #e2e8f0;\n  border-radius: 6px;\n}\n.common-pagination-settings label {\n  white-space: nowrap;\n  color: #1f2937;\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n.common-pagination-settings #clientPerPageSelect, .common-pagination-settings #invoicePerPageSelect, .common-pagination-settings #expensePerPageSelect, .common-pagination-settings #labelPerPageSelect,\n.common-pagination-settings #notePerPageSelect, .common-pagination-settings #userPerPageSelect, .common-pagination-settings #tasksPerPageSelect, .common-pagination-settings #casesPerPageSelect {\n  border: none;\n  border-radius: 6px;\n  outline: none;\n  padding: 3px 28px 3px 3px;\n  background-color: white;\n  font-size: 0.85rem;\n  color: #333;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n  transition: all 0.2s ease;\n  box-shadow: none !important;\n}\n.common-pagination-settings #clientPerPageSelect:hover, .common-pagination-settings #invoicePerPageSelect:hover, .common-pagination-settings #expensePerPageSelect:hover, .common-pagination-settings #labelPerPageSelect:hover,\n.common-pagination-settings #notePerPageSelect:hover, .common-pagination-settings #userPerPageSelect:hover, .common-pagination-settings #tasksPerPageSelect:hover, .common-pagination-settings #casesPerPageSelect:hover {\n  background-color: #fafafa;\n}\n.common-pagination-settings #clientPerPageSelect:focus, .common-pagination-settings #invoicePerPageSelect:focus, .common-pagination-settings #expensePerPageSelect:focus, .common-pagination-settings #labelPerPageSelect:focus,\n.common-pagination-settings #notePerPageSelect:focus, .common-pagination-settings #userPerPageSelect:focus, .common-pagination-settings #tasksPerPageSelect:focus, .common-pagination-settings #casesPerPageSelect:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n  background-color: white;\n}\n.common-pagination-settings #clientPerPageSelect option, .common-pagination-settings #invoicePerPageSelect option, .common-pagination-settings #expensePerPageSelect option, .common-pagination-settings #labelPerPageSelect option,\n.common-pagination-settings #notePerPageSelect option, .common-pagination-settings #userPerPageSelect option, .common-pagination-settings #tasksPerPageSelect option, .common-pagination-settings #casesPerPageSelect option {\n  border: none !important;\n  outline: none;\n  padding: 4px 8px;\n}\n.common-pagination-settings #userPerPageSelect, .common-pagination-settings #tasksPerPageSelect, .common-pagination-settings #casesPerPageSelect {\n  padding: 4px 28px 4px 3px !important;\n}\n\n.lawyer-list {\n  background-color: #f8f9fa;\n  padding: 15px;\n}\n.lawyer-list .filter-group label {\n  display: block;\n  margin-bottom: 8px;\n}\n.lawyer-list .no-lawyers-found {\n  text-align: center;\n  font-size: 1.1rem;\n  color: var(--text-color-medium);\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n  background: var(--card-bg);\n  border-radius: 0.75rem;\n  border: 1px dashed var(--border-color);\n  box-shadow: 0 2px 5px var(--shadow-light);\n  margin-top: calc(var(--spacing-unit) * 2);\n  grid-column: 1/-1;\n}\n.lawyer-list .spreadsheet-filter-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  justify-content: space-between;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  background-color: transparent;\n  color: #444;\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn svg {\n  font-size: 1rem;\n  color: inherit;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .view-toggle-wrapper-user .view-toggle-btn.active {\n  background-color: #e5e7eb;\n  color: #222;\n  border-color: #cbd5e1;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .common-pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 4px 10px;\n  background-color: #e2e8f0;\n  border-radius: 6px;\n}\n.lawyer-list .spreadsheet-filter-header .invoices-header .filter-dropdown-wrapper {\n  margin-left: auto;\n}\n.lawyer-list .lawyer-cards {\n  margin-top: 1rem;\n  display: grid;\n  gap: 1.5rem;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  animation: fadeIn 0.3s ease-out;\n}\n.lawyer-list .lawyer-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  min-height: 180px;\n}\n.lawyer-list .lawyer-card:hover {\n  border-color: #d1d5db;\n}\n.lawyer-list .lawyer-card:hover .userscrud {\n  opacity: 1;\n}\n.lawyer-list .lawyer-card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n.lawyer-list .lawyer-card .card-header h3 {\n  margin: 0;\n  color: #1f2937;\n  font-weight: 600;\n  font-size: 1.1rem;\n  flex: 1;\n}\n.lawyer-list .lawyer-card .card-header .status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.lawyer-list .lawyer-card .card-header .status-badge.active {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.lawyer-list .lawyer-card .card-header .status-badge.inactive {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n.lawyer-list .lawyer-card .card-content {\n  flex: 1;\n}\n.lawyer-list .lawyer-card .card-content .info-item {\n  display: flex;\n  margin-bottom: 0.5rem;\n}\n.lawyer-list .lawyer-card .card-content .info-item .label {\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n  min-width: 60px;\n  margin-right: 0.5rem;\n}\n.lawyer-list .lawyer-card .card-content .info-item .value {\n  color: #374151;\n  font-size: 0.875rem;\n  flex: 1;\n  word-break: break-word;\n}\n.lawyer-list .lawyer-card .card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #f3f4f6;\n}\n.lawyer-list .lawyer-card .card-footer .role-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n.lawyer-list .lawyer-card .card-footer .userscrud {\n  display: flex;\n  gap: 0.5rem;\n  transition: opacity 0.2s ease;\n}\n.lawyer-list .lawyer-card .card-footer .userscrud .btn {\n  margin-right: 0.5rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.lawyer-list .lawyer-card .card-footer .userscrud .btn:hover {\n  background-color: #f8f9fa;\n  opacity: 0.9;\n}\n.lawyer-list .users-table {\n  width: 100%;\n  margin-top: 1rem;\n  border-collapse: collapse;\n  background-color: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px var(--shadow-light);\n}\n.lawyer-list .users-table thead {\n  background-color: var(--light-gray);\n}\n.lawyer-list .users-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: #111827;\n}\n.lawyer-list .users-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n.lawyer-list .users-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n.lawyer-list .users-table tbody tr td {\n  padding: 0.9rem 1rem;\n}\n.lawyer-list .users-table tbody tr td:nth-child(4) .role-badge-status {\n  display: inline-block;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  border-radius: 12px;\n}\n.lawyer-list .users-table tbody tr td:nth-child(4) .role-badge-status.active {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.lawyer-list .users-table tbody tr td:nth-child(4) .role-badge-status.inactive {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n.lawyer-list .users-table tbody tr td:last-child {\n  white-space: nowrap;\n}\n.lawyer-list .users-table tbody tr td:last-child button {\n  margin-right: 0.5rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  background-color: #17a2b8;\n  color: white;\n  opacity: 0.9;\n}\n.lawyer-list .users-table tbody tr td:last-child button:last-child {\n  background-color: #dc2626;\n}\n.lawyer-list .users-table tbody tr td:last-child button:hover {\n  opacity: 0.9;\n}\n.lawyer-list .pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 7px 18px;\n  background-color: #E2E8F0;\n  border-radius: 6px;\n}\n.lawyer-list .pagination-settings label {\n  white-space: nowrap;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n}\n.lawyer-list .pagination-settings #userPerPageSelect {\n  border: none;\n  border-radius: 6px;\n  outline: none;\n  padding: 6px 32px 6px 12px;\n  background-color: white;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  min-width: 70px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n  transition: all 0.2s ease;\n  box-shadow: none !important;\n}\n.lawyer-list .pagination-settings #userPerPageSelect:hover {\n  background-color: #fafafa;\n}\n.lawyer-list .pagination-settings #userPerPageSelect:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n  background-color: white;\n}\n.lawyer-list .pagination-settings #userPerPageSelect option {\n  border: none !important;\n  outline: none;\n  padding: 4px 8px;\n}\n\n@media (max-width: 768px) {\n  .lawyer-list .lawyer-cards .lawyer-card .userscrud {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
